import { observer } from 'mobx-react';
import * as React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useError } from '@components/hooks/useError';
import { PageHeader } from '@components/page-header';
import { links } from '@core/router';
import { toast } from '@core/toast';
import { injectTSDI } from '@core/tsdi';
import { ChallengeDataStore } from '@src/communities/community/challenges/challenge-form/data-store';
import ChallengeFormSteps from '@src/communities/community/challenges/challenge-form/steps';
import { ChallengeActions } from './challange-actions';
import { ChallengeStore } from './store';

export const ChallengeCreateForm = observer(() => {
    const challengeDataStore = injectTSDI(ChallengeDataStore);

    const { isUpdating, hasErrors, createChallenge } =
        injectTSDI(ChallengeStore);
    const { communityId } = useParams();
    const showError = useError();
    const navigate = useNavigate();
    React.useEffect(() => {
        challengeDataStore.initializeWithParams(
            undefined,
            communityId ? Number(communityId) : undefined
        );
    }, [challengeDataStore]);

    return (
        <>
            <PageHeader title="Create Challenge" />
            <div className="pb-24">
                <ChallengeFormSteps />
            </div>
            <ChallengeActions
                communityId={communityId}
                isUpdating={isUpdating}
                onChallengeCreate={async () => {
                    try {
                        await createChallenge(Number(communityId));
                        toast.success('Challenge was created');
                        navigate(links.communityChallenges(communityId));
                    } catch (error) {
                        showError(error);
                    }
                }}
                showCreateButton={true}
                createDisabled={hasErrors || isUpdating}
                showCancelButton={false}
                showEditButton={false}
            />
        </>
    );
});

export default ChallengeCreateForm;
